// extracted by mini-css-extract-plugin
module.exports = {"headerItem":"CdxAiT3A"};